module.exports = __webpack_public_path__ + "img/Truppführer_BrB.134656a4.svg";